import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getBillsListApi } from "../../../services/receptionist.services";
import useQuery from "../../../hooks/useQuery";
import {
  updateUrlSearchParams,
  parsePageParam,
  parseSearchParam,
} from "../../../helpers/urlFilters";
import BillingTable from "./BillingTable";
import { UiDataTable } from "../../ui";

const Billing = () => {
  const navigate = useNavigate();
  const params = useQuery();
  const page = parsePageParam(params);
  const searchQuery = parseSearchParam(params);
  const [billData, setBillData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const setPage = (newPage) => {
    updateUrlSearchParams(navigate, { page: newPage });
  };

  useEffect(() => {
    setLoading(true);
    let queryParams = {
      page: page,
    };
    if (searchQuery) {
      queryParams.search = searchQuery;
      queryParams.page = 1;
    }
    const queryString = new URLSearchParams(queryParams);
    getBillsListApi(queryString)
      .then((res) => {
        setBillData(res?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [searchQuery, page, refresh]);

  const refreshPage = () => {
    setRefresh(!refresh);
  };

  return (
    <UiDataTable
      showHeader={false}
      shellClassName="ui-table-fill-shell"
      onSearch={(e) =>
        updateUrlSearchParams(navigate, {
          search: e?.target?.value || null,
          page: 1,
        })
      }
      searchValue={searchQuery || ""}
      searchPlaceholder="Search for patient"
    >
      <BillingTable
        data={billData}
        page={page}
        setPage={setPage}
        loading={loading}
        refresh={refreshPage}
      />
    </UiDataTable>
  );
};

export default Billing;
